import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { colorPrimary } from "../../../theme";

interface ConcessionariaMiniCardProps {
  logoUrl: string;
  nome: string;
  anuncios: number;
  onClick?: () => void;
  selected?: boolean;
}

export function ConcessionariaMiniCard({
  logoUrl,
  nome,
  anuncios,
  onClick,
  selected = false,
}: ConcessionariaMiniCardProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
      sx={{
        width: isMobile ? "100%" : 192,
        maxWidth: isMobile ? 180 : "none",
        height: isMobile ? 160 : 190,
        p: 2.5,
        borderRadius: 3,
        bgcolor: "background.paper",
        border: "2px solid",
        borderColor: selected ? colorPrimary : "divider",
        boxShadow: selected
          ? "0 0 0 2px rgba(0,0,0,0.02)"
          : "0 2px 6px rgba(0,0,0,0.05)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        textAlign: "center",
        cursor: "pointer",
        outline: "none",
        transition: "all 0.25s ease",

        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 8px 18px rgba(0,0,0,0.12)",
        },

        "&:hover .hover-text": {
          color: colorPrimary,
        },

        "&:focus-visible": {
          outline: `2px solid ${colorPrimary}`,
          outlineOffset: 2,
        },
      }}
    >
      {/* Logo */}
      <Box
        component="img"
        width={"100%"}
        px={1}
        src={logoUrl}
        alt={nome}
        sx={{
          height: 70,
          objectFit: "contain",
          mb: 2,
          pointerEvents: "none",
        }}
      />

      {/* Textos */}
      <Box width="100%" overflow="hidden">
        <Typography
          className="hover-text"
          fontSize="0.85rem"
          fontWeight={700}
          px={2}
          mb={0.5}
          sx={{
            transition: "color 0.25s ease",
            color: selected ? colorPrimary : "inherit",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          {nome}
        </Typography>

        <Typography
          className="hover-text"
          fontSize="0.75rem"
          sx={{
            transition: "color 0.25s ease",
            color: selected ? colorPrimary : "text.secondary",
          }}
        >
          {anuncios} anúncios
        </Typography>
      </Box>
    </Box>
  );
}
